import React, { useState, useEffect } from 'react';
import classes from './Button.module.scss'

//import IcCircle from '../../../images/icons/ic-circle.svg'
//import IcCircleClose from '../../../images/icons/ic-circleclose.svg';
import IcCheck from '../../../images/icons/ic-checkmark.png'
import IcClose from '../../../images/icons/ic-close.png';
//import IcUnselect from '../../../images/icons/ic-unselected.svg';



const Button = props => {
    //const style = props.style?? {backgroundColor: props?.backgroundColor ?? '#009DDC', marginTop : '5px', width:"80%"};

    const style = props.style?? {
        background: props?.background ?? process.env.REACT_APP_BUTTON_DEFAULT_BACKGROUND,        
        borderRadius: props?.borderRadius ?? process.env.REACT_APP_BUTTON_BORDER_RADIUS,         
        //backgroundColor: props?.backgroundColor ?? process.env.REACT_APP_BUTTON_DEFAULT_BACKGROUND_COLOR, 
        marginTop : '5px', 
        width:"100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "50px"
    };
    
    const outerBorderStyle = props.outerBorderStyle?? {
        position: "absolute", 
        top: "-47px" , 
        left: "5px", 
        border: "1px solid #4c4c4c", 
        borderLeft: "none", 
        borderTop: "none", 
        borderRadius: "10px", 
        height: "50px",
        zIndex: "0px"
    }
    
    const [icon, setIcon] = useState(null);
    
    const button = 
        <button style={style} 
            onClick={props.onClick} 
            className={props.outlined ? classes.OutlinedButton : classes.MaterialButton}>
                {props.btnText}
        </button>

    const buttonWithIcon = 
        <div style={style} 
            onClick={props.onClick} 
            className={props.outlined ? classes.OutlinedButton : classes.MaterialButton}>                
            <div style={{
                width: "92%",
                paddingLeft: "8%"
                }}>{props.btnText}</div>
                <div style={{
                        width: "8%",
                        flex: "0 0 auto",
                        fontSize: "16px",
                        padding: "0 5px",
                        position: "relative",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#fff",
                        height: "inherit",
                        backgroundColor : "transparent",
                        fillOpacity: 0
                    }}>
                {icon && <img alt="Button icon" style={{
                        fillOpacity: 0
                }} src={icon}/>}

            </div>
        </div>

    useEffect(()=> {
        
        if(props.iconType) {
            let iconSource;
            switch(props.iconType) {
                case 'circle':
                    //iconSource = IcCircle;
                    break;
                case 'circle-close':
                    //iconSource = IcCircleClose;
                    break;
                case 'check':
                    iconSource = IcCheck;
                    break;
                case 'unselect':
                    //iconSource = IcUnselect;
                    break;
                case 'close':
                    iconSource = IcClose;
                    break;                    
                default: 
                    break;
            }
            setIcon(iconSource);
        }
    }, [props.iconType])

    return (
        <div>

            {props.iconType ? buttonWithIcon : button}   
            {/* {process.env.REACT_APP_BUTTON_DECORATIVE_BORDER && 
                <div style={outerBorderStyle}/>
            } */}

        </div>

    );
}

export default Button;
